import type { IconSvgObject } from './types';

const OptionIcon: IconSvgObject = [
  ["path", { d: "M4 5H7.68121C8.48126 5 9.20434 5.47679 9.5195 6.21216L14.4805 17.7878C14.7957 18.5232 15.5187 19 16.3188 19H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 5H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default OptionIcon;
